/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import cn from 'classnames';
import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
function builtInOrTheme(builtin, theme) {
    return builtin ? builtin : theme.button;
}
export var natureColor = function (theme) { return ({
    default: theme.colors.secondary700,
    primary: theme.colors.primary,
    success: theme.colors.success,
    info: theme.colors.info,
    alarm: theme.colors.alarm,
    warning: theme.colors.warning,
}); };
export var buttonBaseStyle = function (_a) {
    var theme = _a.theme, size = _a.size, nature = _a.nature, builtinSize = _a.builtinSize;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    background: ", ";\n    color: ", ";\n    cursor: pointer;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    font-size: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    line-height: 1;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    box-sizing: border-box;\n    vertical-align: middle;\n    text-align: center;\n    text-decoration: none;\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background: ", ";\n    }\n  "], ["\n    position: relative;\n    background: ", ";\n    color: ", ";\n    cursor: pointer;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    font-size: ", ";\n    border-radius: ",
        ";\n    padding: ", ";\n    line-height: 1;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    box-sizing: border-box;\n    vertical-align: middle;\n    text-align: center;\n    text-decoration: none;\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background: ", ";\n    }\n  "])), theme.button.default.bg, natureColor(theme)[nature], theme.borderColor, builtInOrTheme(builtinSize, theme)[size].fontSize, builtInOrTheme(builtinSize, theme)[size]
        .borderRadius, builtInOrTheme(builtinSize, theme)[size].padding, theme.button.default.hoverBg, theme.button.default.activeBg);
};
export var subtleStyle = function (_a) {
    var subtle = _a.subtle, selected = _a.selected, theme = _a.theme, nature = _a.nature;
    return subtle && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border: 1px solid transparent;\n\n    &:hover {\n      background: ", ";\n    }\n  "], ["\n    background: ", ";\n    color: ",
        ";\n    border: 1px solid transparent;\n\n    &:hover {\n      background: ", ";\n    }\n  "])), selected ? theme.button.subtle.bg : 'transparent', nature === 'default'
        ? theme.button.subtle.color
        : natureColor(theme)[nature], theme.button.subtle.hoverBg);
};
export var flatStyle = function (_a) {
    var flat = _a.flat, nature = _a.nature, theme = _a.theme;
    return flat && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    background: ",
        ";\n    color: ",
        ";\n    border-color: ",
        ";\n\n    &:hover {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n    &:active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "])), nature === 'default'
        ? theme.button.flat.bg
        : natureColor(theme)[nature], nature === 'default'
        ? natureColor(theme).default
        : theme.button.flat.color, nature === 'default'
        ? theme.button.flat.bg
        : natureColor(theme)[nature], nature === 'default'
        ? theme.button.flat.hoverBg
        : lighten(0.1, natureColor(theme)[nature]), nature === 'default'
        ? theme.borderColor
        : lighten(0.1, natureColor(theme)[nature]), nature === 'default'
        ? theme.button.flat.activeBg
        : darken(0.12, natureColor(theme)[nature]), nature === 'default'
        ? theme.button.flat.activeBorderColor
        : darken(0.12, natureColor(theme)[nature]));
};
export var lightStyle = function (_a) {
    var light = _a.light, theme = _a.theme, nature = _a.nature;
    return light && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n    &:active {\n      background: ", ";\n    }\n  "], ["\n    background: ", ";\n    color: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n    &:active {\n      background: ", ";\n    }\n  "])), theme.button.light.bg, natureColor(theme)[nature], theme.button.light.hoverBg, theme.button.light.activeBg);
};
export var linkStyle = function (_a) {
    var link = _a.link, theme = _a.theme;
    return link && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border: 1px solid transparent;\n\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  "], ["\n    background: ", ";\n    color: ", ";\n    border: 1px solid transparent;\n\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  "])), theme.button.link.bg, theme.button.link.color, theme.button.link.hoverBg, theme.button.link.hoverColor);
};
export var linkDarkStyle = function (_a) {
    var link = _a.link, dark = _a.dark, theme = _a.theme;
    return link &&
        dark && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme.button.link.darkColor, theme.button.link.hoverDarkColor);
};
var underlineStyle = function (_a) {
    var underline = _a.underline;
    return underline && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    &:hover {\n      text-decoration: underline;\n    }\n  "], ["\n    &:hover {\n      text-decoration: underline;\n    }\n  "])));
};
export var circleStyle = function (_a) {
    var circle = _a.circle;
    return circle && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    border-radius: 100%;\n    width: 2.066rem;\n    line-height: 2.066rem;\n    height: 2.066rem;\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    border-radius: 100%;\n    width: 2.066rem;\n    line-height: 2.066rem;\n    height: 2.066rem;\n  "])));
};
export var Button = styled('button').attrs(function (props) { return ({
    type: 'button',
    className: cn('vital__button', props.className),
}); })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  /* Basic */\n  ", "\n  /* subtle */\n  ", "\n  /* flat */\n  ", "\n  /* light */\n  ", "\n  /* link */\n  ", "\n  ", "\n\n  /* underline */\n  ", "\n\n  /* circle */\n  ", "\n\n  ", "\n\n  &[disabled] {\n    color: ", ";\n    border-color: ", ";\n    background: ", ";\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n  ", ";\n"], ["\n  /* Basic */\n  "
    // @ts-ignore
    ,
    "\n  /* subtle */\n  ", "\n  /* flat */\n  ", "\n  /* light */\n  ", "\n  /* link */\n  ", "\n  ", "\n\n  /* underline */\n  ", "\n\n  /* circle */\n  ", "\n\n  ", "\n\n  &[disabled] {\n    color: ", ";\n    border-color: ", ";\n    background: ", ";\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n  ", ";\n"])), 
// @ts-ignore
buttonBaseStyle, subtleStyle, flatStyle, lightStyle, linkStyle, linkDarkStyle, underlineStyle, circleStyle, superBoxStyle, function (_a) {
    var theme = _a.theme;
    return theme.button.disabled.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.button.disabled.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.button.disabled.bg;
}, function (props) { return props.theme.button.buttonStyle; });
Button.defaultProps = {
    theme: defaultTheme,
    children: '',
    nature: 'default',
    size: 'medium',
    circle: false,
    light: false,
    flat: false,
    link: false,
    subtle: false,
    selected: false,
    disabled: false,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
/**
 * @render react
 * @name Button
 * @description Button component with group
 * @example
 * <ButtonGroup>
 *   <Button nature="default" size="xlarge">Default</Button>
 *   <Button nature="primary" size="large">Default</Button>
 *   <Button nature="success" size="medium">Default</Button>
 *   <Button nature="info" size="small">Default</Button>
 *   <Button nature="alarm" size="xsmall">Default</Button>
 *   <Button nature="warning">Default</Button>
 *   <Button flat>Default</Button>
 *   <Button subtle>Default</Button>
 *   <Button light>Default</Button>
 *   <Button link>Default</Button>
 * </ButtonGroup>
 */
//# sourceMappingURL=Button.js.map